import React from "react"
import { Helmet } from "react-helmet"
import { ThemeProvider } from "styled-components"

import * as S from "./style"
import favicon from "../../assets/favicon/betmgm/favicon.ico"
import * as localFont from "../../assets/fonts/stylesheet.css"
import { fetchGlobalData } from "../../helpers/getData"
import GlobalStyle from "../../styles/globalStyle"
import { themes } from "../../styles/themes"

const { REACT_APP_THEME: theme } = process.env

const NotAvailable = () => {
  const [logo, setLogo] = React.useState(null)

  React.useEffect(() => {
    fetchGlobalData("pt-br")
      .then(data => setLogo(data.logo))
      .catch(() => {})
  }, [])

  return (
    <ThemeProvider theme={themes[theme]}>
      <Helmet htmlAttributes={{ lang: "pt-BR" }}>
        <title>BetMGM - Temporariamente indisponível</title>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="icon" href={favicon} />
      </Helmet>
      <GlobalStyle $localFontStylesheet={localFont} />
      <S.Container>
        <S.Nav>
          <S.NavInner>{logo && <S.Logo src={logo} alt="BetMGM" />}</S.NavInner>
        </S.Nav>
        <S.Main>
          <S.Content>
            <h1>Comunicado aos nossos clientes e parceiros:</h1>
            <p>
              Em cumprimento às novas regras vigentes no Brasil, os jogos online estão indisponíveis no momento. Mais informações sobre a{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://help.betmgm.bet.br/hc/pt-br/articles/30606176123420-ATUALIZA%C3%87%C3%83O-Medida-Provis%C3%B3ria-n%C2%BA-1-394-2026"
              >
                Medida Provisória nº 1.394/2026
              </a>
            </p>
          </S.Content>
        </S.Main>
      </S.Container>
    </ThemeProvider>
  )
}

export default NotAvailable
